var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { observer } from 'mobx-react';
import { Button } from '@bytebrand/fe-ui-core-autobahn/ui';
import classNames from 'classnames';
import FormInput from '../../../ui/FormInput/FormInput';
import CredentialsForm from '../../../pages/SettingsPage/forms/CredentialsForm';
import styles from './CredentialsModal.styl';
let CredentialsModal = class CredentialsModal extends React.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "renderForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t, onConfirm, onDecline } = this.props;
                const emailField = CredentialsForm.$('email');
                const passField = CredentialsForm.$('password');
                const buttonDisabled = (!emailField.changed || !emailField.isValid) && (!passField.changed || !passField.isValid);
                const buttonLoading = CredentialsForm.validating || CredentialsForm.submitting;
                const classRowFlex = classNames(styles.formRow, styles.rowFlex);
                return (React.createElement("div", { className: styles.formContainer },
                    React.createElement("div", { key: 'email', className: styles.formRow },
                        React.createElement("div", { className: styles.formColumn },
                            React.createElement(FormInput, { field: CredentialsForm.$('email'), t: t }))),
                    React.createElement("div", { key: 'password', className: classRowFlex },
                        React.createElement("div", { className: styles.formColumn },
                            React.createElement(FormInput, { autoComplete: 'off', field: CredentialsForm.$('password'), shouldTruncate: false, t: t, type: 'password' }))),
                    React.createElement("div", { className: styles.buttonContainer },
                        React.createElement(Button, { variant: 'outlined', className: styles.cancelButton, onClick: onDecline }, t('forms.cancel')),
                        React.createElement(Button, { variant: 'filled', className: styles.saveButton, disabled: buttonDisabled || buttonLoading, onClick: onConfirm }, buttonLoading ? React.createElement("span", { className: 'auth-spinner', style: { width: 18, height: 18, borderWidth: 2 } }) : t('forms.save')))));
            }
        });
    }
    render() {
        const { t } = this.props;
        return (React.createElement("div", { className: styles.wrapper },
            React.createElement("h4", { className: styles.heading }, t('credentialsModal.changeCredential')),
            this.renderForm()));
    }
};
CredentialsModal = __decorate([
    observer
], CredentialsModal);
export default CredentialsModal;
